import { defineView } from "eddev/views"

export default defineView("_html", (props) => {
  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: props.htmlContent }} />
    </div>
  )
})
